// @ts-ignore
import { generateActions } from './utils'

const accountDefinition = {
  read: ['id'],
}

export const accountActions = generateActions(['ACCOUNT'], accountDefinition)

export default accountActions
